import {ReactElement} from "react";

import iconDL from "@/assets/massification/iconDownload.svg";
import IconLink from "@/assets/massification/iconLink.svg";
import Button from "@/components/Button/Button";
import {getBFF} from "@/function/getUrlProdOrPreprod";
import {FichierApi} from "@/ts/interface/operationCommerciale";

export function FileAndLinkToDL({
  liens,
  fichiers,
}: {
  liens?: {nom: string; lien: string}[];
  fichiers?: FichierApi[];
}): ReactElement {
  const Liens = liens?.map((lien, index) => {
    return (
      <Button
        label={lien.nom}
        variant="validate"
        icon={IconLink}
        key={`${lien.nom} ${index}`}
        onClick={() => window.open(lien.lien, "_blank")}
      />
    );
  });
  const FichiersToDl = (): JSX.Element[] | null => {
    const handleDownload = async (id: number): Promise<void> => {
      const url = await `${getBFF()}/operation/v1/fichiers/${id}`;
      window.open(url, "_blank");
    };
    if (fichiers?.length) {
      const fichiersComponent = fichiers?.map(fichier => {
        return (
          <Button
            label={fichier.nom}
            variant="validate"
            icon={iconDL}
            key={fichier.fichierId}
            onClick={() => handleDownload(fichier.fichierId)}
          />
        );
      });
      return fichiersComponent;
    }
    return null;
  };
  return (
    <>
      {Liens}
      {FichiersToDl()}
    </>
  );
}
